import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedAttributesListForNro = lazy(
  () => import("@segments/CalculatedAttributesList/CalculatedAttributesListForNro")
);

export const calculatedAttributesListNRO: NavigationRoutingObject = {
  Component: CalculatedAttributesListForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-attributes-sidebar-pill-menu-option", "Calculated Attributes"),
  pageNameForTracking: () => "Calculated Attributes",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-attributes-description-nav", "Manage the aggregated value created from event data"),
  icon: "nav-system-custom-attributes",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("custom_calculated_attributes"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_attributes/:appGroupId",
};
